import React from 'react';
import { Typography, Box } from '@mui/material';

const faqStyles = {
  mt: 2,
};

const questionStyles = {
  fontWeight: 'bold',
};

export default function FAQ() {
  return (
    <Box p={3}>
      <Typography variant="h4">
        Frequently Asked Questions
      </Typography>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          What is Claritev?
        </Typography>
        <Typography variant="body2">
          Claritev has been a data warehouse for self-insured employers across the
          country, in every industry and region since 2012.
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          What does the modeling and benchmark database consist of?
        </Typography>
        <Typography variant="body2">
          The database includes over 1 million member lives and billions of de-identified
          medical claims records, sometimes spanning over 10 years to account for
          pre-existing conditions like cancer and heart attacks.
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          How does Claritev review the benchmarks?
        </Typography>
        <Typography variant="body2">
          Claritev conducts actuarial reviews of the benchmarks.
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          How does Claritev use machine learning algorithms?
        </Typography>
        <Typography variant="body2">
          Claritev uses machine learning algorithms to model voluntary benefits for a
          given census, providing predicted utilization and payout amounts by product
          and benefit/provision.
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          What does Ceres do with the Supplemental Carrier&apos;s policy documents?
        </Typography>
        <Typography variant="body2">
          Ceres matches the Supplemental Carrier&apos;s policy documents and claim payout
          standards to the de-identified census from the employer, providing predicted
          utilization and payout amounts by product and provision.
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          What are the census requirements for Ceres?
        </Typography>
        <Typography variant="body2">
          The census requirements include AGE (or DOB), GENDER, STATE, and PERSON
          TYPE (EE, SP, CH).
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          How does back testing affect Ceres projections?
        </Typography>
        <Typography variant="body2">
          The larger the census, the lower the variance. The more common the condition,
          the more accurate the predictions.
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          How can carriers&apos; sales teams use this tool?
        </Typography>
        <Typography variant="body2">
          Carriers&apos; sales teams can use this tool to show brokers the value of
          health products for an employer/client.
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          How does this tool elevate conversations with Employes?
        </Typography>
        <Typography variant="body2">
          It elevates conversations with employers about the need for supplemental products.
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          Can different plans and benefit amounts be modeled?
        </Typography>
        <Typography variant="body2">
          Yes, different plans, benefit amounts, tiers, and configurations can be modeled.
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          What can be determined for employees/members?
        </Typography>
        <Typography variant="body2">
          Potential benefit payouts for employees/members for supplemental health products
          can be determined.
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          What benchmarks can be reviewed?
        </Typography>
        <Typography variant="body2">
          Demographic benchmarks can be reviewed.
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          How does this tool reveal product value?
        </Typography>
        <Typography variant="body2">
          It reveals the product(s) with the most potential value to the employees.
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          How can results be leveraged for new clients?
        </Typography>
        <Typography variant="body2">
          Results can be leveraged in new clients for RFPs and finalist presentations.
        </Typography>
      </Box>
      <Box sx={faqStyles}>
        <Typography variant="subtitle1" sx={questionStyles}>
          How can results be leveraged for existing clients?
        </Typography>
        <Typography variant="body2">
          Results can be leveraged in existing clients for positioning improved
          enrollment conditions.
        </Typography>
      </Box>
    </Box>
  );
}
